var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    "toggleSection",
                    "smartObjectAndBackgroundSection"
                  )
                },
              },
            },
            [
              _c("strong", [_vm._v("SmartObject & Background")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.smartObjectAndBackgroundSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                {
                  attrs: {
                    visible: _vm.isOpen.smartObjectAndBackgroundSection,
                  },
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "smart-object-ui-container" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "select-smart-object",
                                  label: "Smart Object",
                                  "label-for": "select-smart-object",
                                },
                              },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    id: "select-smart-object",
                                    options: _vm.smartObjectsList,
                                    "text-field": "name",
                                    "value-field": "id",
                                  },
                                  on: { change: _vm.onSelectSmartObject },
                                  model: {
                                    value: _vm.selectedSmartObjectFieldId,
                                    callback: function ($$v) {
                                      _vm.selectedSmartObjectFieldId = $$v
                                    },
                                    expression: "selectedSmartObjectFieldId",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "mb-2",
                            attrs: { inline: true, "aria-label": "show" },
                            on: {
                              change: function ($event) {
                                return _vm.onChange("showBackground", $event)
                              },
                            },
                            model: {
                              value: _vm.smartObjectData.showBackground,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.smartObjectData,
                                  "showBackground",
                                  $$v
                                )
                              },
                              expression: "smartObjectData.showBackground",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Show background\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.smartObjectFabricRectangleObject
        ? _c("PositionAndSize", {
            attrs: {
              "aspect-ratio-option": false,
              h:
                _vm.smartObjectFabricRectangleObject.height *
                _vm.smartObjectFabricRectangleObject.scaleY,
              w:
                _vm.smartObjectFabricRectangleObject.width *
                _vm.smartObjectFabricRectangleObject.scaleX,
              x: parseFloat(_vm.smartObjectFabricRectangleObject.left),
              y: parseFloat(_vm.smartObjectFabricRectangleObject.top),
              "is-open": _vm.isOpen,
            },
            on: {
              toggleSection: _vm.toggleSectionHandler,
              input: _vm.onChange,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "generalSettingsSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("General Settings")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.generalSettingsSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.generalSettingsSection } },
                [
                  _c(
                    "div",
                    _vm._l(
                      _vm.option5FilteredSettings,
                      function (setting, key) {
                        return _c(
                          "b-form-group",
                          {
                            key: key,
                            staticClass: "mb-1",
                            attrs: { id: key },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "d-flex",
                                          style:
                                            key === "shadow"
                                              ? "gap: 0px"
                                              : "gap: 8px",
                                        },
                                        [
                                          key === "shadow"
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "b-form-checkbox",
                                                    {
                                                      staticClass:
                                                        "mr-0 pr-0 pb-1",
                                                      attrs: {
                                                        inline: true,
                                                        "aria-label": "show",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onChange()
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.smartObjectData
                                                            .showShadow,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.smartObjectData,
                                                            "showShadow",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "smartObjectData.showShadow",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.getSettingKeyName(
                                                              key
                                                            ) + " Setting"
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            key === "skew" && setting && setting?.value
                              ? _c("SkewForm", {
                                  attrs: {
                                    tl: [setting.value[0], setting.value[1]],
                                    tr: [setting.value[2], setting.value[3]],
                                    br: [setting.value[4], setting.value[5]],
                                    bl: [setting.value[6], setting.value[7]],
                                    "is-render": setting?.render,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChange("skew", $event)
                                    },
                                  },
                                })
                              : key === "warp" && setting && setting?.value
                              ? _c("WarpForm", {
                                  attrs: {
                                    "is-render": setting?.render,
                                    "show-grid": setting?.showGrid,
                                    editing: setting?.editing,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChange("warp", $event)
                                    },
                                  },
                                })
                              : _c(
                                  "div",
                                  [
                                    key !== "shadow" || setting.enabled
                                      ? _vm._l(
                                          _vm.getKeys(setting),
                                          function (settingKey) {
                                            return _c(
                                              "b-form-row",
                                              {
                                                key: settingKey,
                                                staticClass: "ml-1",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            "input-" +
                                                            settingKey,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              settingKey
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                                settingKey.slice(
                                                                  1
                                                                )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "9" } },
                                                  [
                                                    _c(
                                                      "b-row",
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass: "pl-0",
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                id:
                                                                  "input-range-" +
                                                                  settingKey,
                                                                max: _vm.rules[
                                                                  settingKey
                                                                ].max,
                                                                min: _vm.rules[
                                                                  settingKey
                                                                ].min,
                                                                step: _vm.rules[
                                                                  settingKey
                                                                ].step,
                                                                type: "range",
                                                                disabled:
                                                                  !_vm.checkIsSettingEnabled(
                                                                    setting
                                                                  ),
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onChange(
                                                                      settingKey,
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .smartObjectData[
                                                                    settingKey
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.smartObjectData,
                                                                      settingKey,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "smartObjectData[settingKey]",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "m-0 pl-0",
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                id:
                                                                  "input-" +
                                                                  settingKey,
                                                                max: _vm.rules[
                                                                  settingKey
                                                                ].max,
                                                                min: _vm.rules[
                                                                  settingKey
                                                                ].min,
                                                                step: _vm.rules[
                                                                  settingKey
                                                                ].step,
                                                                disabled:
                                                                  !_vm.checkIsSettingEnabled(
                                                                    setting
                                                                  ),
                                                                type: "number",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onChange(
                                                                      settingKey,
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .smartObjectData[
                                                                    settingKey
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.smartObjectData,
                                                                      settingKey,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "smartObjectData[settingKey]",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "membersSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Members")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.membersSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.membersSection } },
                [
                  _c(
                    "div",
                    [
                      _c("b-form-group", { attrs: { id: "members" } }, [
                        _vm.hoveredItem !== "data:,"
                          ? _c("img", {
                              staticClass: "member-thumbnail",
                              attrs: { src: _vm.hoveredItem, alt: "empty" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column members-container",
                          },
                          [
                            _vm._l(_vm.fieldsOptions, function (object) {
                              return _c(
                                "b-form-checkbox",
                                {
                                  key: object.value,
                                  staticClass: "member-item",
                                  attrs: {
                                    id: object.value + "_checkbox",
                                    checked: object.isMember,
                                    inline: true,
                                    name: object.value + "_checkbox",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateAdditionalFieldsMembers(
                                        object.value
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.hoveredItem = object.thumbnail
                                        },
                                        mouseleave: function ($event) {
                                          _vm.hoveredItem = "data:,"
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(object.name) +
                                          "\n                  "
                                      ),
                                      object.isText
                                        ? _c("b-icon", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.viewport.noninteractive",
                                                value: "Edit Text",
                                                expression: "'Edit Text'",
                                                modifiers: {
                                                  hover: true,
                                                  viewport: true,
                                                  noninteractive: true,
                                                },
                                              },
                                            ],
                                            staticClass: "ml-1",
                                            attrs: { icon: "pencil" },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                              },
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.setActiveObject(
                                                  object
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.additionalFields, function (object) {
                              return _c(
                                "b-form-checkbox",
                                {
                                  key: object.value,
                                  staticClass: "member-item",
                                  attrs: {
                                    id: object.value + "_checkbox",
                                    checked: object.isMember,
                                    inline: true,
                                    name: object.value + "_checkbox",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateAdditionalFieldsMembers(
                                        object.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.hoveredItem = object.thumbnail
                                        },
                                        mouseleave: function ($event) {
                                          _vm.hoveredItem = "data:,"
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(object.name) +
                                          "\n                  "
                                      ),
                                      object.isText
                                        ? _c("b-icon", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.viewport.noninteractive",
                                                value: "Edit Text",
                                                expression: "'Edit Text'",
                                                modifiers: {
                                                  hover: true,
                                                  viewport: true,
                                                  noninteractive: true,
                                                },
                                              },
                                            ],
                                            staticClass: "ml-1",
                                            attrs: { icon: "pencil" },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                              },
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.setActiveObject(
                                                  object
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "actionSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Actions")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.actionSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.actionSection } },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "shape-editor-actions d-flex mb-3",
                        staticStyle: { "grid-gap": "0.2rem" },
                      },
                      [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Scale to template size" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("scaleToTemplateSize")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: { src: "/img/icons/full-screen.svg" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Center in template" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("centerToTemplateSize")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/center-image.svg",
                                alt: "center-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Center Horizontally" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("centerToTemplateWidth")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/align-center.png",
                                alt: "align-center-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Center Vertically" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("centerToTemplateHeight")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/vertical-alignment.png",
                                alt: "align-center-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Set to half of canvas width" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("setToHalfOfCanvasWidth")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/panel-left.svg",
                                alt: "panel-left-icon",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-btn",
        { attrs: { variant: "danger" }, on: { click: _vm.onDelete } },
        [_vm._v("\n    Delete Smart Object\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true },
            },
          ],
          attrs: {
            title: _vm.lockedState ? "Unlock" : "Lock",
            variant: "outline-primary",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              _vm.lockedState = !_vm.lockedState
            },
          },
        },
        [
          _c("b-icon", {
            attrs: { icon: _vm.lockedState ? "lock-fill" : "unlock" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }